import type React from "react"
import { cn } from "@/lib/utils"

export function PluralisIcon(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg
      {...props}
      width="48"
      height="48"
      viewBox="0 0 48 48"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={cn("h-6 w-6", props.className)}
    >
      <path
        d="M24 42C33.9411 42 42 33.9411 42 24C42 14.0589 33.9411 6 24 6C14.0589 6 6 14.0589 6 24C6 33.9411 14.0589 42 24 42Z"
        fill="hsl(var(--primary))"
      />
      <path d="M24 6C14.0589 6 6 14.0589 6 24C6 33.9411 14.0589 42 24 42V6Z" fill="hsl(var(--primary))" />
      <path
        d="M24 6C18.1667 6 13.6667 10.3333 12.1667 15.8333C13.6667 10.3333 18.1667 6 24 6Z"
        fill="#FBBF24" // gold-400
      />
      <path
        d="M12.1667 15.8333C10.5 21.8333 12.1667 28.5 16.6667 33.1667C12.1667 28.5 10.5 21.8333 12.1667 15.8333Z"
        fill="#FBBF24" // gold-400
      />
      <path
        d="M16.6667 33.1667C19.5 37.6667 25.1667 41.1667 31.3333 41.5C25.1667 41.1667 19.5 37.6667 16.6667 33.1667Z"
        fill="#FBBF24" // gold-400
      />
      <path
        d="M24 6C19.3333 6 15.5 9.5 14 14C15.5 9.5 19.3333 6 24 6Z"
        fill="#F87171" // red-400
      />
      <path
        d="M14 14C11.8333 20.5 13.6667 27.8333 18.3333 32.5C13.6667 27.8333 11.8333 20.5 14 14Z"
        fill="#F87171" // red-400
      />
      <path
        d="M18.3333 32.5C21.1667 37 26.8333 40.5 33 40.8333C26.8333 40.5 21.1667 37 18.3333 32.5Z"
        fill="#F87171" // red-400
      />
    </svg>
  )
}
